// The scene's weather on the board (issue 1163): a faint whole-board veil and its name, for everyone it reaches — the
// DM whenever a weather is set, a player while the scene's vision is on (the server sends them its name then, and only
// then). One translucent layer over the canvas, never a per-square paint: berry renders WebGL in software, and what
// the fog hides is already cut by the server's sight.
import { useTableState } from '../table/TableState';

export function WeatherOverlay() {
  const { store } = useTableState();
  const w = store.state.weather;
  if (!w) return null;
  return (
    <div className="pointer-events-none absolute inset-0" data-testid="board-weather">
      <div className="absolute inset-0 bg-slate-300/10" />
      <span className="absolute bottom-2 left-2 rounded bg-stone-900/80 px-2 py-0.5 text-xs text-stone-200">Weather: {w.label}</span>
    </div>
  );
}
